import { Check, Pause, Workflow } from 'lucide-react';

interface FunnelStatsProps {
    totalFunnels: number;
    activeFunnels: number;
    inactiveFunnels: number;
}

export default function FunnelStats({
    totalFunnels,
    activeFunnels,
    inactiveFunnels
}: FunnelStatsProps) {
    const stats = [
        {
            label: 'Total de Funis',
            value: totalFunnels,
            icon: Workflow,
            text: 'text-blue-600',
            lightBg: 'bg-blue-50',
            border: 'border-blue-100',
        },
        {
            label: 'Funis Ativos',
            value: activeFunnels,
            icon: Check,
            text: 'text-emerald-600',
            lightBg: 'bg-emerald-50',
            border: 'border-emerald-100',
        },
        {
            label: 'Funis Inativos',
            value: inactiveFunnels,
            icon: Pause,
            text: 'text-gray-600',
            lightBg: 'bg-gray-50',
            border: 'border-gray-200',
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {stats.map((stat) => (
                <div
                    key={stat.label}
                    className={`relative overflow-hidden rounded-xl border ${stat.border} bg-white p-5 hover:shadow-lg transition-all duration-300 group`}
                >
                    <div className={`absolute top-0 right-0 w-32 h-32 ${stat.lightBg} rounded-full blur-3xl opacity-30 -mr-16 -mt-16 group-hover:opacity-50 transition-opacity`} />

                    <div className="relative z-10">
                        <div className="flex items-center justify-between mb-4">
                            <div className={`p-2.5 rounded-lg ${stat.lightBg}`}>
                                <stat.icon className={`h-5 w-5 ${stat.text}`} strokeWidth={1.5} />
                            </div>
                        </div>
                        <h3 className="text-sm font-medium text-gray-600 mb-1">{stat.label}</h3>
                        <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}